<template>
  <Dialog ref="dialog"
          width="450px"
          @confirm="verify"
          :show-confirm="onLoad === 0"
          icon="fas fa-bookmark"
          title="Cargar órdenes de transporte">
    <div v-if="onLoad === 0">
      <div class="param">
        <p class="title">FECHA</p>
        <p class="content">El {{formatDate(extraParams.date)}}</p>
      </div>
      <div class="param">
        <p class="title">CT / CTT</p>
        <p class="content"
           :class="tagNotCT">{{extraParams.ct.name}}</p>
      </div>
      <div class="param">
        <p class="title">TIPO DE DOCUMENTO</p>
        <el-form>
          <el-form-item ref="DocumentTypeForm">
            <el-select  v-model="documentType"
                        value-key="id"
                        size="mini"
                        filterable
                        @change="checkDocumentType"
                        placeholder="Ej: XD">
              <el-option  v-for="documentType in documentTypes"
                          :key="documentType.id"
                          :label="documentType.name"
                          :value="documentType"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <p class="info">* Seleccione Fecha y CT/CTT desde la sección DATOS GENERALES.</p>
    </div>
    <div v-else>
      <div class="param">
        <p class="title">BUSCANDO POR:</p>
        <p class="content">
          Tipo de documento <b>{{documentType.name}}</b>
          del <b>{{formatDate(extraParams.date)}}</b>
          en <b>{{extraParams.ct.name}}</b>.</p>
        <div class="result">
          <span v-if="onLoad === 2">
            <i class="el-icon-folder-checked"/> Consulta finalizada:
            <p>Total encontradas: <b>{{countTOTotal}}</b></p>
            <p>Nuevas órdenes agregadas: <b>{{countTO}}</b></p>
            <p>Órdenes ya existentes: <b>{{countTOTotal - countTO}}</b></p>
          </span>
          <span v-else-if="onLoad === 3">
            <i class="el-icon-close"/> Error al procesar la solicitud.
          </span>
          <span v-else><i class="el-icon-loading"/> Procesando solicitud ...</span>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import moment from 'moment';
import { cachedAPIRequest } from '@/mixins/cacheDim';
import { apiRequest } from '@/backend/vue-axios/axios';
import Dialog from '../../base/Dialog.vue';

export default {
  name: 'GetTO',
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      tagNotCT: '',
      extraParams: {
        ct: {},
      },
      documentType: {},
      documentTypes: [],
      aux: [],
      onLoad: 0,
      countTO: 0,
      countTOTotal: 0,
    };
  },
  mounted() {
    this.getDocumentTypes();
  },
  methods: {
    open(params) {
      this.tagNotCT = '';
      this.aux = [];
      this.countTO = 0;
      this.countTOTotal = 0;
      this.onLoad = 0;
      this.extraParams = params;
      if (!this.extraParams.ct.id) {
        this.extraParams.ct.name = 'No seleccionado';
        this.tagNotCT = 'red-tag';
      }
      this.$refs.dialog.visible(true);
    },
    checkDocumentType() {
      if (this.documentType.id) {
        this.$refs.DocumentTypeForm.validateState = undefined;
        this.$refs.DocumentTypeForm.validateMessage = undefined;
      }
    },
    verify() {
      const err = [];
      if (!this.extraParams.date) err.push('Fecha');
      if (!this.extraParams.ct.id) err.push('CT/CTT');
      if (!this.documentType.id) {
        err.push('Tipo de documento');
        this.$refs.DocumentTypeForm.validateState = 'error';
        this.$refs.DocumentTypeForm.validateMessage = 'No seleccionado';
      }
      if (err.length > 0) {
        this.$refs.dialog.loading(false);
        this.$notify({
          type: 'warning',
          title: 'Parámetros faltantes',
          message: `Seleccione ${err.join(', ')}.`,
        });
      } else {
        this.getTO();
      }
    },
    getTO() {
      this.onLoad = 1;
      apiRequest({
        module: 'planning',
        service: 'get_to',
        params: {
          date: this.extraParams.date,
          ct_id: this.extraParams.ct.id,
          document_type_id: this.documentType.id,
          /* test data
          date: '2019-09-27T15:04:05Z'
          ct_id: 2000,
          document_type_id: 24,
          */
        },
      }).then((response) => {
        response.data.forEach((val) => {
          if (val.last_state === -1 && val.current_do !== -1) {
            Object.assign(val, { last_state: 1, last_state_name: 'Digitado' });
          }
          const sectors = this.sectors.filter(sector => (sector.packageTypes
            .map(l => l.id).includes(val.package_type_id)
            || (sector.packageTypes.length > 0 && val.package_type_name === 'NF'))
            && sector.localities.map(l => l.id).includes(val.locality_id)
            && ![5, 6].includes(val.last_state));
          Object.assign(val, { sectors, verified: true });
          this.aux.push(val);
        });
        this.countTOTotal = this.aux.length;
        this.aux = this.aux
          .filter(s => !(this.value.map(soc => soc.suborder)).includes(s.suborder));
        this.countTO = this.aux.length;
        this.onLoad = 2;
        this.$emit('input', this.aux.concat(this.value));
        this.$refs.dialog.loading(false);
      }).catch((error) => {
        if (error.response.status === 404) {
          this.onLoad = 2;
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error obtener las ordenes',
          });
          this.onLoad = 3;
        }
        this.$refs.dialog.loading(false);
      });
    },
    getDocumentTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'document_type',
        params: { limit: 1000 },
      }).then((response) => {
        this.documentTypes = response.data
          .map(documentType => ({ id: documentType.id, name: documentType.type }))
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los tipos de documento',
        });
      });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
  .param {
    margin-bottom: 20px;
    i {
      color: $fb-green;
      font-weight: 900;
    }
    .el-icon-close{ color: $fb-red !important; }
    .title {
      font-weight: 600;
      color: $fb-green;
      margin: 10px 0 0;
    }
    .content { margin: 2px 0 0; }
    .content, .result {
      color: $fb-grey-light-20;
      font-weight: 300;
    }
    .result {
      margin-top: 20px;
      p { margin: 5px 5px 5px 15px; }
    }
  }
  .info {
    margin: 30px 0 0;
    color: $fb-grey-light-50;
  }
  .param, .info { font-size: 13px; }
  .red-tag {
    color: $fb-red !important;
    font-weight: 500 !important;
  }
</style>
